// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35lCu","textarea":"styles_textarea__XyIBj"};